export enum RedirectAction {
    ToCategory = 1,
    ToForHour = 2
}
